import {React, useEffect, useState} from 'react';
import { Component, createRef, } from 'react';
import { Navigation } from './commons/navigation.tsx';
import ToolsContent from './commons/tools-content-architecture.tsx';
import { Notifications } from './commons/notifications.tsx';
import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  ContentLayout,
  Flashbar,
  Header,
  Form,
  SpaceBetween,
  Button,
  ColumnLayout,
  HelpPanel,
  Link,
  SideNavigation,
  SplitPanel,
} from '@cloudscape-design/components';
import plant_madrid from './static/plant_madrid.jpg';
import plant_munich from './static/plant_munich.jpg';
import plant_berlin from './static/plant_berlin.png';


function ContentBlock({city, img_src, data, description, temperatureC, moisture, humidity, wateredDif, wateredUnit}){

    return(
      
      <div className="plant-block">
        <h2>{city}</h2>
        <img
          src={img_src}
          alt={'Icon of ' + city}
          
          style={{
            maxWidth: '80%', 
            height: 'auto',  
          }}      
        />
        <h3>
          Plant Type:
        </h3>
        <h4>{data.plantType}</h4>
        <ul>
          <li>Temperature: {temperatureC}  C </li> 
          <li>Humidity:  {humidity} %</li>
          <li>Moisture:  {moisture} %</li>
          <li>Last Watered {wateredDif} {wateredUnit} ago</li>
        </ul>
      </div>
    )
}

async function fetchPlantData() {
    try {
      const response = await getPlantData();
      console.log("new ---");
      console.log(response);
      return(response);
    } catch (error) {
      console.error('Error fetching plant data:', error);
    }
} 

function getPlantData(){
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", "https://cz1u81blw8.execute-api.eu-central-1.amazonaws.com/test/plants");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.responseType = "json";
      xhr.onload = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const data = JSON.parse(xhr.response.body);
          console.log(data);
          const plantData = data;
          resolve(plantData);
        } else {
          console.log(`Error: ${xhr.status}`);
          reject(`Error: ${xhr.status}`);
        }
      };
      xhr.send();
    });
}

class Data extends Component {
    componentDidMount(){

        getPlantData().then((response) => {
                  let munich = response.munich;
                  console.log("Response Munich:");
                  console.log(munich);
                  let berlin = response.lasvegas;
                  let madrid = response.madrid;
                  let paris = response.paris;
                  let munichDesc = response.munich.information.description;
                  let berlinDesc = response.lasvegas.information.description;
                  let madridDesc = response.madrid.information.description;
                  let parisDesc = response.paris.information.description;
                  let munichTempC = response.munich.metrics.temperatureC;
                  let parisTempC = response.paris.metrics.temperatureC;
                  let madridTempC = response.madrid.metrics.temperatureC;
                  let berlinTempC = response.lasvegas.metrics.temperatureC;
                  let munichHumidity = response.munich.metrics.humidity;
                  let parisHumidity = response.paris.metrics.humidity;
                  let madridHumidity = response.madrid.metrics.humidity;
                  let berlinHumidity = response.lasvegas.metrics.humidity;
                  let munichMoisture = response.munich.metrics.moisture;
                  let parisMoisture = response.paris.metrics.moisture;
                  let madridMoisture = response.madrid.metrics.moisture;
                  let berlinMoisture = response.lasvegas.metrics.moisture;
                  let munichWateredLastDifference = response.munich.wateredLast.difference_pst;
                  let munichWateredLastUnit = response.munich.wateredLast.unit_pst;
                  let parisWateredLastDifference = response.paris.wateredLast.difference_pst;
                  let parisWateredLastUnit = response.paris.wateredLast.unit_pst;
                  let madridWateredLastDifference = response.madrid.wateredLast.difference_pst;
                  let madridWateredLastUnit = response.madrid.wateredLast.unit_pst;
                  let berlinWateredLastDifference = response.lasvegas.wateredLast.difference_pst;
                  let berlinWateredLastUnit = response.lasvegas.wateredLast.unit_pst;
                  this.setState({
                      munich: munich,
                      berlin: berlin,
                      madrid: madrid,
                      paris: paris,
                      munichDesc: munichDesc,
                      parisDesc: parisDesc,
                      madridDesc: madridDesc,
                      berlinDesc: berlinDesc,
                      munichTempC: munichTempC,
                      parisTempC: parisTempC,
                      madridTempC: madridTempC,
                      berlinTempC: berlinTempC,
                      munichHumidity: munichHumidity,
                      parisHumidity: parisHumidity,
                      madridHumidity: madridHumidity,
                      berlinHumidity: berlinHumidity,
                      munichMoisture: munichMoisture,
                      parisMoisture: parisMoisture,
                      madridMoisture: madridMoisture,
                      berlinMoisture: berlinMoisture,
                      munichWateredLastDifference: munichWateredLastDifference,
                      madridWateredLastDifference: madridWateredLastDifference,
                      parisWateredLastDifference: parisWateredLastDifference,
                      berlinWateredLastDifference: berlinWateredLastDifference,
                      munichWateredLastUnit: munichWateredLastUnit,
                      madridWateredLastUnit: madridWateredLastUnit,
                      parisWateredLastUnit: parisWateredLastUnit,
                      berlinWateredLastUnit: berlinWateredLastUnit,
    
    
                  });
              })
    
    
    
      }
      constructor(props) {
        super(props);
        this.state = { toolsIndex: 0, toolsOpen: false, tags: [], valid: true, loading: true, munich: {}, berlin: {}, madrid: {}, paris: {}, munichDesc: "", berlinDesc: "", madridDesc: "", parisDesc: "", munichTempC: 0, berlinTempC: 0, madridTempC: 0, parisTempC: 0, munichMoisture: 0, parisMoisture: 0, madridMoisture: 0, berlinMoisture: 0, munichHumidity: 0, parisHumidity: 0, madridHumidity: 0, berlinHumidity: 0, munichWateredLastUnit: "", madridWateredLastUnit: "", parisWateredLastUnit: "", berlinWateredLastUnit: "", munichWateredLastDifference: 0, madridWateredLastDifference: 0, parisWateredLastDifference: 0, berlinWateredLastDifference: 0 };
        // this.appLayout = createRef();
        
      }

      content() {
        const handleInfoClick = () => {
          this.setState({ toolsIndex: 0, toolsOpen: true });
          this.appLayout.current?.focusToolsClose();
        };
        return (
          <ContentLayout header={<Header variant="h1">Detailed Plant View</Header>}>
            <form onSubmit={event => event.preventDefault()}>
              <Form
                actions={
                  <SpaceBetween direction="horizontal" size="xs">
                    {/* <Button variant="link">Cancel</Button> */}
                    <Button variant="primary">Add plant</Button>
                  </SpaceBetween>
                }
              >
                
                <Container
                  header={
                    <Header
                      variant="h2"
                      description="Quickly find information about different plants, understand the plant type and current metrics."
                    >
                      Details
                    </Header>
                  }
                >
                  {/* <TagEditor
                    tags={this.state.tags}
                    onChange={this.onChange.bind(this)}
                    keysRequest={() => window.FakeServer.GetTagKeys().then(({ TagKeys }) => TagKeys)}
                    valuesRequest={key => window.FakeServer.GetTagValues(key).then(({ TagValues }) => TagValues)}
                    loading={this.state.loading}
                    i18nStrings={tagEditorI18nStrings}
                  /> */}
                  <ColumnLayout columns={3} variant="text-grid">
                    <div>
                      
                      <ContentBlock city="Madrid" img_src={plant_madrid} data={this.state.madrid} description={this.state.madridDesc} humidity={this.state.madridHumidity} temperatureC={this.state.madridTempC} moisture={this.state.madridMoisture} wateredDif={this.state.madridWateredLastDifference} wateredUnit={this.state.madridWateredLastUnit} />
                    </div>
                    <div>
                      
                      <ContentBlock city="Munich" img_src={plant_munich} data={this.state.munich} description={this.state.munichDesc} humidity={this.state.munichHumidity} temperatureC={this.state.munichTempC} moisture={this.state.munichMoisture} wateredDif={this.state.munichWateredLastDifference} wateredUnit={this.state.munichWateredLastUnit} />
                    </div>
                    <div>
                      
                      <ContentBlock city="Berlin" img_src={plant_berlin} data={this.state.berlin} description={this.state.berlinDesc} humidity={this.state.berlinHumidity} temperatureC={this.state.berlinTempC} moisture={this.state.berlinMoisture} wateredDif={this.state.berlinWateredLastDifference} wateredUnit={this.state.berlinWateredLastUnit} />
                    </div>
                  </ColumnLayout>
                  <ColumnLayout columns={3} variant="text-grid">
                    <div>
                      Generated1
                     
                    </div>
                    <div>
                    Generated2
                      
                    </div>
                    <div>
                    Generated3
                      
                    </div>
                  </ColumnLayout>
                </Container>
              </Form>
            </form>
          </ContentLayout>
        );
}
}

export default function () {
    const [toolsOpen, setToolsOpen] = useState(true);
    const [navOpen, setNavOpen] = useState(true);
  
    return (
        <AppLayout
          breadcrumbs={
            <BreadcrumbGroup
              items={[
                { text: 'Plantly', href: '#' },
                { text: 'Architecture', href: '#' },
              ]}
            />
          }
          navOpen={navOpen}
          onNavChange={({ detail }) => setNavOpen(detail.open)}
          navigation={<Navigation activeHref="/architecture" />}
          notifications={<Notifications />}
          toolsOpen={toolsOpen}
          onToolsChange={({ detail }) => setToolsOpen(detail.open)}
          tools={ToolsContent}
          content={this.content()}
        />
    );
  }





